
import React from 'react';
import CalculatorPage from './components/CalculatorPage';

function App() {
  return (
    <main className="min-h-screen bg-slate-50 text-slate-800">
      <CalculatorPage />
    </main>
  );
}

export default App;
